export default __webpack_public_path__ + "static/4-442e36f08b3db48677aff26ba163fc89.png";